import { useEffect, useRef, useState } from "react";

export default function useProgress() {
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);

  const intervalRef = useRef(null);

  const clearProgressInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const start = () => {
    clearProgressInterval();

    setLoading(true);
    setProgress(0);

    intervalRef.current = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) {
          clearProgressInterval();
          return 90;
        }

        // Random increment between 3 and 10
        const next = prev + Math.floor(Math.random() * 8) + 3;

        return next > 90 ? 90 : next;
      });
    }, 300);
  };

  const complete = () => {
    clearProgressInterval();

    setProgress(100);

    setTimeout(() => {
      setLoading(false);
      setProgress(0);
    }, 500);
  };

  const error = () => {
    clearProgressInterval();

    setLoading(false);
    setProgress(0);
  };

  const reset = () => {
    clearProgressInterval();

    setLoading(false);
    setProgress(0);
  };

  useEffect(() => {
    return () => {
      clearProgressInterval();
    };
  }, []);

  return {
    progress,
    loading,
    start,
    complete,
    error,
    reset,
  };
}